var $d376dd5b16d08137$exports = {};
$d376dd5b16d08137$exports = {
    "help": `S\xfag\xf3`,
    "info": `Inform\xe1ci\xf3`
};


export {$d376dd5b16d08137$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
